import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pan: ''
}

const employeePanSlice = createSlice({
    name: 'employeePan',
    initialState,
    reducers: {
        setPan: (state, action) => {
            state.pan = action.payload.pan
        },
        resetEmployeePan: () => initialState
    }
})

export const { setPan, resetEmployeePan } = employeePanSlice.actions;
export default employeePanSlice.reducer;